<template>
  <div class="mt-10">
    <div class="grid grid-cols-4 leading-tight items-center">
      <div class="col-span-4 xs:col-span-2 xl:col-span-4 xxl:col-span-2">
        <span class="text-4xl font-semibold text-primary-black">
          {{ totalAmount.toFixed(0) }}
        </span>
        <span class="font-normal text-xl text-black">EUR</span>
      </div>
      <div class="col-span-4 xs:col-span-2 xl:col-span-4 xxl:col-span-2 xs:text-right xl:text-left xxl:text-right">
        <span class="text-4xl font-semibold text-green-300">{{ monthlyPayment.toFixed(2) }}</span>
        <span class="ml-1 text-xl font-normal text-green-400">EUR /</span>
        <span class="ml-1 font-normal text-xl text-black">kuu</span>
      </div>
    </div>
    <div class="slider-container mt-6">
      <!-- TODO: keskmisel ekraanil jookseb tekst peale -->
      <span class="font-semibold tracking-wider text-sm text-primary-black">Sissemakse %</span>
      <input type="range" min="0" max="100" step="5" class="slider" v-model="depositPercentage" :key="tempKey"/>
    </div>
    <div class="percent-ticks">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="slider-container mt-16">
      <span class="font-semibold tracking-wider text-sm text-primary-black">Periood</span>
      <input type="range" min="0" max="24" step="1" class="slider" v-model="period"/>
    </div>
    <div class="month-ticks">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="flex flex-wrap xxl:flex-no-wrap items-center justify-center mt-16">
      <div class="mx-2 xl:mx-4">
        <span class="text-primary-black tracking-wide text-base uppercase font-semibold">Sissemakse:</span>
        <span class="ml-1 text-orange-400 font-medium text-3xl">{{ depositAmount }}</span>
        <span class="ml-1 text-orange-400 font-light text-xl">EUR</span>
      </div>
      <div class="mx-2 xl:mx-4">
        <span class="text-primary-black text-base tracking-wide uppercase font-semibold">Periood:</span>
        <span class="ml-1 text-orange-400 font-medium text-3xl">{{ period }}</span>
        <span class="ml-1 text-orange-400 font-light text-xl">kuud</span>
      </div>
      <!--      <div class="col-span-2 md:col-span-1 xl:col-span-4 text-right xs:text-left">-->
      <!--        <span class="text-4xl font-semibold text-green-300">0</span>-->
      <!--        <span class="text-2xl font-normal text-green-400">%</span>-->
      <!--        <span class="ml-1 font-normal text-xl text-black">intress</span>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Calculator",
  data: () => ({
    tempKey: 0
  }),
  computed: {
    totalAmount: function () {
      return this.$store.getters['prices/GET_TOTAL_AMOUNT']
    },
    period: {
      get() {
        return this.$store.getters['prices/GET_PERIOD']
      },
      set(newValue) {
        this.$store.dispatch('prices/PERIOD', newValue)
      }
    },
    depositAmount: function () {
      return this.$store.getters['prices/GET_DEPOSIT_AMOUNT'].toFixed(0)
    },
    monthlyPayment: function () {
      return this.$store.getters['prices/GET_MONTHLY_PAYMENT']
    },
    depositPercentage: {
      get() {
        return this.$store.getters['prices/GET_DEPOSIT_PERCENTAGE']
      },
      set(newValue) {
        const percentage = +newValue < 30 ? 30 : +newValue
        this.$store.dispatch('prices/DEPOSIT_PERCENTAGE', percentage)
        if (+newValue < 30) this.tempKey++
      }
    },
  },

};
</script>

<style>
</style>
